import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, CardActions, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Backdrop, CircularProgress, Modal, Box, Divider, InputLabel, Select, ButtonGroup } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined, Co2, Forest, PaymentsOutlined, LocalGasStationOutlined, ScaleOutlined, DeleteForeverOutlined, DeleteOutline } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { formatDate } from '../../helpers/custom';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    community_id: string;
    community_details: any;
    pageSize: number;
    anchorEl: any;
    payment_data: any[];
    showEditCommunity: boolean;
    name: string;
    city_id: string;
    route_address: string;
    type: string;
    incentives: string;
    newspaper: string;
    pincode: any;
    transaction_data: any;
    totalWaste: any;
    treesSaved: any;
    fuelSaved: any;
    duration: any;
    showCustomDateFilter: any,
    customFromDate: any,
    customToDate: any,
    earnings: any,
    page: any;
    ecoStatData: any;
    wallet_page: any;
    wallet_pagesize: any;
    showAddPaymentModal: boolean;
    imageBase64: any;
    payment_amount: any;
    payment_type: any;
    payment_comment: any;
    impactImage: any,
    impactTitle: any,
    showImpactModal: boolean,
    created_at: any;
}

class NeighbourhoodDetails extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            community_id: this.props.match.params.id,
            community_details: {},
            impactTitle: "",
            pageSize: 20,
            anchorEl: null,
            payment_data: [],
            showEditCommunity: false,
            imageBase64: "",
            name: "",
            city_id: '',
            route_address: '',
            type: '',
            incentives: '',
            newspaper: '',
            pincode: null,
            transaction_data: [],
            totalWaste: 4536,
            treesSaved: 7384,
            fuelSaved: 3843,
            duration: 'month',
            showCustomDateFilter: false,
            customFromDate: null,
            customToDate: null,
            earnings: 4857,
            page: 0,
            ecoStatData: {},
            wallet_page: 0,
            wallet_pagesize: 20,
            showAddPaymentModal: false,
            payment_amount: '',
            impactImage: null,
            showImpactModal: false,
            payment_type: '',
            payment_comment: '',
            created_at: '',
        }
    }
    public downloadImpactImage = () => {
    if (!this.state.imageBase64) {
        toast.error("No image to download");
        return;
    }
    const communityName =
        this.state.community_details?.name?.replace(/\s+/g, "_") || "community";

    const formatMonthYear = (date: Date) =>
        date.toLocaleString("en-US", { month: "short", year: "numeric" });

    const buildDurationLabel = (start: Date, end: Date) => {
        const startText = formatMonthYear(start);
        const endText = formatMonthYear(end);
        return startText === endText ? startText : `${startText}-${endText}`;
    };

    let durationLabel = "";
    const today = new Date();

    if (this.state.duration === "today") {
        durationLabel = formatMonthYear(today);
    }
    else if (this.state.duration === "week") {
        const start = new Date();
        start.setDate(today.getDate() - 7);
        durationLabel = buildDurationLabel(start, today);
    }
    else if (this.state.duration === "month") {
        const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const end = new Date(today.getFullYear(), today.getMonth(), 0);
        durationLabel = buildDurationLabel(start, end);
    }
    else if (
        this.state.duration === "custom" &&
        this.state.customFromDate &&
        this.state.customToDate
    ) {
        durationLabel = buildDurationLabel(
            this.state.customFromDate,
            this.state.customToDate
        );
    }
    else {
        durationLabel = "Custom";
    }

    const fileName = `${communityName}(${durationLabel}).png`;

    const a = document.createElement("a");
    a.href = this.state.imageBase64;
    a.download = fileName;
    a.click();
};


    public componentDidMount(): void {
        this.fetchCommunityDetails();
        this.fetchCommunityEcoStats();
        // this.fetchWalletPayments();
    }

    public fetchCommunityDetails(page: number = this.state.page, limit: number = this.state.pageSize){
        this.setState({showLoader: true});
        let body = {
            "community_id": this.state.community_id,
            "hierarchies": this.props.user.selectedHierarchyIds,
        }
        axios.post('getCommunityDetails', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                let data : any = response.data.data;
                this.setState({showLoader: false});
                
                this.setState({community_details: {
                        "id": data.community.id,
                        "name": data.community.name,
                        "incentives": data.community.commission,
                        "created_at": data.community.created_at,
                        "type": data.community.type,
                        "address": data.community.address,
                        "pincode": data.community.pincode,
                        "priority": data.community.priority_type,
                        "status": data.community.is_active == 1 ? "Active": "Inactive",
                        "balance": data.balance,
                        "wallet_id": data.community.wallet_id,
                }});
                // console.log("details", this.state.community_details);
                this.fetchWalletPayments(data.community.wallet_id);
                this.fetchWalletTransactions(data.community.wallet_id);

            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchCommunityEcoStats (filter: string = this.state.duration) {
        this.setState({ showLoader: true });
        let date = new Date();
        let body: any = {
            "community_id": this.state.community_id,
            "hierarchies": this.props.user.selectedHierarchyIds,
        }
        
        if (filter == "custom") {
            body.start_date = (this.state.customFromDate) ? formatDate(this.state.customFromDate, 'Y-m-d') : "";
            body.end_date = (this.state.customToDate) ? formatDate(this.state.customToDate, 'Y-m-d') : "";
        } else if(filter == 'month') {
            // console.log('filter', filter)
            // body.start_date = formatDate(date.setDate(date.getDate() - 30), 'Y-m-d');
            body.start_date = formatDate(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'Y-m-d');
            // body.end_date = formatDate(new Date(), 'Y-m-d');
            body.end_date = formatDate(new Date(date.getFullYear(), date.getMonth(), 0), 'Y-m-d');
            // body.filter = filter;
        } else if(filter == 'week') {
            // console.log('filter', filter)
            body.start_date = formatDate(date.setDate(date.getDate() - 7), 'Y-m-d');
            body.end_date = formatDate(new Date(), 'Y-m-d');
            // body.filter = filter;
        } else if(filter == 'today'){
            // console.log('filter', filter)
            body.start_date = formatDate(new Date(), 'Y-m-d');
            body.end_date = formatDate(new Date(), 'Y-m-d');
        }
        axios.post('getCommunityEcoStats', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                // console.log("res", response.data.data);
                this.setState({ecoStatData: response.data.data, showLoader: false});
            } else {
                // console.log("err");
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
    }
    public generateMyImpact = async () => {
    const { duration, customFromDate, customToDate, community_id } = this.state;
    const encodedId = btoa(String(community_id));

    let start_date = "";
    let end_date = "";
    let today = new Date();

    if (duration === "custom") {
        start_date = customFromDate ? formatDate(customFromDate, "Y-m-d") : "";
        end_date   = customToDate   ? formatDate(customToDate, "Y-m-d") : "";
    } 
    else if (duration === "today") {
        start_date = end_date = formatDate(today, "Y-m-d");
    } 
    else if (duration === "week") {
        start_date = formatDate(new Date(today.setDate(today.getDate() - 7)), "Y-m-d");
        end_date   = formatDate(new Date(), "Y-m-d");
    } 
    else if (duration === "month") {
        const now = new Date();
        start_date = formatDate(new Date(now.getFullYear(), now.getMonth() - 1, 1), "Y-m-d");
        end_date   = formatDate(new Date(now.getFullYear(), now.getMonth(), 0), "Y-m-d");
    }

    this.setState({ showLoader: true });

    return axios.get(`my-impact/${encodedId}`, {     // IMPORTANT ← return added
        params: { start_date, end_date ,title: this.state.impactTitle },
        
    })
    .then((res) => {
        if (res.data.success) {
            this.setState({
                impactImage: res.data.url,
                imageBase64: res.data.image_base64,
                showLoader: false,
                showImpactModal:true
            });
        }
    })
    .catch(() => {
        this.setState({ showLoader: false });
        toast.error("Failed to generate impact image");
    });
};


    public fetchWalletPayments (wallet_id: any, page: number = this.state.wallet_page, limit: number = this.state.wallet_pagesize) {
        // this.setState({showLoader: true});
        let body = {
            "wallet_id": wallet_id,
            "hierarchies": this.props.user.selectedHierarchyIds,
            "limit": limit,
            "page": page+1,
        }
        axios.post('getWalletPayments', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                // console.log("res", response.data.data);
                this.setState({payment_data: response.data.data.payments})
                
            } else {
                // console.log("err");
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
    }

    public fetchWalletTransactions (wallet_id: any, page: number = this.state.wallet_page, limit: number = this.state.wallet_pagesize) {
        // this.setState({showLoader: true});
        let body = {
            "wallet_id": wallet_id,
            "hierarchies": this.props.user.selectedHierarchyIds,
            "limit": limit,
            "page": page+1,
        }
        axios.post('getWalletTransactions', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                // console.log("res", response.data.data);
                this.setState({transaction_data: response.data.data?.transactions})
                
            } else {
                // console.log("err");
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        const maskedCellSx = isUatEnvironment
            ? {
                filter: 'blur(4px)',
                opacity: 0.5,
                userSelect: 'none',
            }
            : undefined;
        const renderMaskedCell = (value: React.ReactNode) => (
            <Box component="span" sx={maskedCellSx}>
                {value}
            </Box>
        );

        const handleRouteMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({ anchorEl: event.currentTarget });
        };

        const closeRouteMoreOptions = () => {
            setTimeout(() => {
                this.setState({ anchorEl: null });
            }, 1);
        };

        const handlePriorityChange = (event: any) => {
            console.log(event.currentTarget.value);
        };

        const toggleRouteStatus = () => {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds, "community_id": this.state.community_id };
            axios.post(`toggleCommunityStatus`, options).then((response: any) => {
                this.setState({ showLoader: false, anchorEl: null });
                toast.success('Route ' + ((this.state.community_details.status == 'Active') ? 'Deactivated' : 'Activated') + ' Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchCommunityDetails();
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const toggleCustomerStatus = (customerId: any, status: string, user_id: any) => {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds, "community_id": this.state.community_id, "community_user_id": customerId, "customer_id": user_id };
            axios.post(`toggleCommunityUserStatus`, options).then((response: any) => {
                this.setState({ showLoader: false, anchorEl: null });
                toast.success('Customer ' + ((status == 'Active') ? 'Deactivated' : 'Activated') + ' Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchCommunityDetails();
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleEditRoute = ((data: any) => {
            closeRouteMoreOptions();
            this.setState({
                showEditCommunity: true,
                community_id: data.id,
                name: data.route,
                city_id: data.city_id,
                route_address: data.address,
                type: data.generator
            })
        })

        const handleUpdateCommunity = (() => {
            this.setState({ showLoader: true });
            let data = {
                community_id: this.state.community_id,
                name: this.state.community_details?.name,
                address: this.state.community_details?.address,
                type: this.state.community_details?.type,
                commission: this.state.community_details?.incentives,
                priority_type: this.state.community_details?.priority,
                pincode: this.state.community_details?.pincode
            };
            axios.post(`communityInlineEdit`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                if(response.data.success){
                    this.setState({ showEditCommunity: false, showLoader: false });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchCommunityDetails();
                }else{
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showEditCommunity: false, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        })

        const handleAddPayment = () => {
            this.setState({showLoader: true});
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "amount": this.state.payment_amount,
                "title": this.state.payment_comment,
                "type": this.state.payment_type,
                "wallet_id": this.state.community_details?.wallet_id,
            }
            axios.post('addMoneyToWallet', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if(response.data.success){
                    this.setState({showLoader: false,})
                    toast.success("Community added", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchWalletPayments(this.state.community_details.wallet_id);
                } else {
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({showLoader: false, })
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const walletColumns: any = [
            {
                headerName: t("Id"),
                field: "id",
                width: 100,
            },
            {
                headerName: "Type",
                field: "type",
                width: 180
            },
            {
                headerName: t("Title"),
                field: "title",
                width: 450
            },
            {
                headerName: t("Amount"),
                field: "amount",
                width: 150,
                renderCell: (params: GridCellParams) =>
                    renderMaskedCell(params.value),
            },
            {
                headerName: t("Updated"),
                field: "updated_at",
                width: 200
            },
            
        ];


        const transactionColumns: any = [
            {
                headerName: t("Id"),
                field: "id",
                width: 100,
            },
            {
                headerName: "Type",
                field: "type",
                width: 180
            },
            {
                headerName: t("Title"),
                field: "title",
                width: 450
            },
            {
                headerName: t("Amount"),
                field: "amount",
                width: 150,
                renderCell: (params: GridCellParams) =>
                    renderMaskedCell(params.value),
            },
            {
                headerName: t("Status"),
                field: "status",
                width: 150
            },
            {
                headerName: t("Updated"),
                field: "updated_at",
                width: 200
            },
            
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                // avatar={
                                //     <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/neighbourhood/community-list'}><KeyboardArrowLeftRounded /></Button>
                                // }
                                avatar={
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        className="customBackButton"
                                        onClick={() => {
                                            if (this.props.history.length > 1) {
                                                this.props.history.goBack();
                                            } else {
                                                this.props.history.push('/neighbourhood/community-list');
                                            }
                                        }}
                                    >
                                        <KeyboardArrowLeftRounded />
                                    </Button>
                                }
                                
                                
                                title={t("Community Details")}
                                className="text-left"
                                action={
                                    <CardActions sx={{padding: 0}}>
                                        <Button variant='contained' size="small" component={Link} to={'/neighbourhood/community-list/' + this.state.community_details.id + '/pickups'} className='link'>Pickups</Button>
                                        <Button variant='contained' size="small" component={Link} to={'/neighbourhood/community-list/' + this.state.community_details.id + '/users'} className='link'>Users</Button>
                                        <IconButton aria-label="route-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleRouteMoreOptions(e)}>
                                            <MoreHorizOutlined id="route-more-options-button" sx={{ outline: 'none !important' }} />
                                            <Menu
                                                id="route-more-options-menu"
                                                aria-labelledby="route-more-options-button"
                                                anchorEl={this.state.anchorEl}
                                                open={open}
                                                onClose={() => closeRouteMoreOptions()}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <MenuItem className='customMenuItem' onClick={() => handleEditRoute(this.state.community_details)}>{t("Edit Community Details")}</MenuItem>
                                                <MenuItem className='customMenuItem' onClick={() => toggleRouteStatus()}>{(this.state.community_details.status == 'Active') ? 'Deactivate' : 'Activate'} {t("Community")}</MenuItem>
                                                {/* <MenuItem className='customMenuItem' onClick={() => closeRouteMoreOptions()}>Delete Route</MenuItem> */}
                                            </Menu>
                                        </IconButton>
                                    </CardActions>
                                }
                            />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails">
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Community Id")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {this.state.community_details?.id}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Name")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {renderMaskedCell(this.state.community_details?.name)}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Incentives")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {this.state.community_details?.incentives}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Registration Date")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {this.state.community_details?.created_at}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Type")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {this.state.community_details?.type}
                                                    </Grid>

                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails">
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Address")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {renderMaskedCell(this.state.community_details?.address)}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Pincode")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {renderMaskedCell(this.state.community_details?.pincode)}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Priority")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {this.state.community_details?.priority}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Community Status")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className={'detailsValue ' + ((this.state.community_details.status == 'Active') ? 'statusTextSuccess' : 'statusTextError')}>
                                                        {this.state.community_details?.status}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        {t("Balance")}
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {this.state.community_details?.balance}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                
                <Grid container spacing={2} >
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader title={
                                <>
                                    <Typography variant='h4' className='page-title'>
                                        {t("Eco Stats")}
                                      <Box sx={{ display: "flex", gap: 3, float: "right" }}>
                                        <Button
                                            variant="contained"
                                            onClick={async () => await this.generateMyImpact()}
                                        >
                                            Impact
                                        </Button>
                                        <ButtonGroup variant="contained" className="diversionButtonGroup float-right" aria-label="Material Flow of Diverted Waste button group">
                                            <Button className={(this.state.duration == 'today') ? "active" : ""} onClick={() => { this.setState({ duration: 'today' }); this.fetchCommunityEcoStats('today')}}>{t("Today")}</Button>
                                            <Button className={(this.state.duration == 'week') ? "active" : ""} onClick={() => { this.setState({ duration: 'week' }); this.fetchCommunityEcoStats('week')}}>{t("Week")}</Button>
                                            <Button className={(this.state.duration == 'month') ? "active" : ""} onClick={() => { this.setState({ duration: 'month' }); this.fetchCommunityEcoStats('month') }}>{t("Previous Month")}</Button>
                                            <Button className={(this.state.duration == 'custom') ? "active" : ""} onClick={() => { this.setState({ duration: 'custom', showCustomDateFilter: true }); }}>{t("Custom")}</Button>
                                        </ButtonGroup>
                                       </Box>                                     
                                    </Typography>
                                </>
                            } sx={{textAlign: 'left'}}/>
                            <CardContent>
                            <Grid container spacing={2} className='mt-2 mb-4'>
                                    <Grid item md={2.4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <Co2 sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="h5" component="div">
                                                    {"~"} {Math.floor(this.state.ecoStatData?.co2)} {"kg"}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    CO<sub>2</sub> eq {t("Averted")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={2.4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <Forest sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="h5" component="div">
                                                    {"~"} {Math.floor(this.state.ecoStatData?.tree_saved)}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Trees Saved")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={2.4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <LocalGasStationOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="h5" component="div">
                                                    {"~"} {Math.floor(this.state.ecoStatData?.oil_saved)} {"L"}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Fuel Saved")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={2.4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <PaymentsOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="h5" component="div">
                                                    {Math.floor(this.state.ecoStatData?.rupees)} {"₹"}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Earnings")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={2.4} xs={12} className="text-center"> 
                                     <Card sx={{ justifyContent: "center", display: "flex" }}>
                                         <CardContent>
                                             <DeleteOutline sx={{ width: 56, height: 56, color: '#204d36' }} />
                                             <Typography variant="h5" component="div">
                                                 {Math.floor(this.state.ecoStatData?.weight)} {"kg"}
                                             </Typography>
                                             <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                 {t("Total Kgs")}
                                             </Typography>
                                         </CardContent>
                                     </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item md={6} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={t("Payments")}
                                className="text-left"
                                action={
                                    <Button variant='contained' size="small" onClick={() => this.setState({showAddPaymentModal: true})}>Add Payment</Button>
                                }
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label={t("Payments")}
                                    columns={walletColumns}
                                    rows={this.state.payment_data}

                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={6} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={t("Transactions")}
                                className="text-left"
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label={t("Transactions")}
                                    columns={transactionColumns}
                                    rows={this.state.transaction_data}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showEditCommunity}
                    onClose={() => this.setState({ showEditCommunity: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Edit Community")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showEditCommunity: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="community-name-input"
                                            label={t("Community Name") + " *"}
                                            value={this.state.community_details?.name}
                                            onChange={(e: any) => this.setState({ community_details: {...this.state.community_details, name: e.target.value}})}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    {/* <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("City")} *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.city_id}
                                                onChange={(e) => this.setState({ city_id: e.target.value })}
                                                displayEmpty
                                                label={t("City") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.props.user.selectedHierarchies.map((city: any, key: number) => {
                                                        return (<MenuItem key={key} value={city.id}>{city.name}</MenuItem>);
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Community Address") + " *"}
                                            value={this.state.community_details?.address}
                                            onChange={(e: any) => this.setState({ community_details: {...this.state.community_details, address: e.target.value}})}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Incentives") + " *"}
                                            value={this.state.community_details?.incentives}
                                            onChange={(e: any) => this.setState({ community_details: {...this.state.community_details, incentives: e.target.value}})}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    {/* <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Newspaper") + " *"}
                                            value={this.state.community_details?.news_paper}
                                            onChange={(e: any) => this.setState({ community_details: {...this.state.community_details, news_paper: e.target.value}})}
                                            fullWidth={true}
                                        />
                                    </Grid> */}
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Pincode") + " *"}
                                            value={this.state.community_details?.pincode}
                                            onChange={(e: any) => this.setState({ community_details: {...this.state.community_details, pincode: e.target.value}})}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="type-label">{t("Type")} *</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                value={this.state.community_details?.type}
                                                onChange={(e) => this.setState({ community_details : {...this.state.community_details, type: e.target.value} })}
                                                displayEmpty
                                                label={t("Type") + " *"}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={2} value={"zone"}>{t("Zone")}</MenuItem>
                                                <MenuItem key={2} value={"community"}>{t("Community")}</MenuItem>
                                                <MenuItem key={1} value={"society"}>{t("Society")}</MenuItem>
                                                <MenuItem key={2} value={"corporate"}>{t("Corporate")}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel>{t("Priority")}</InputLabel>
                                            <Select
                                                labelId='type-priority'
                                                value={this.state.community_details?.priority}
                                                onChange={(e) => this.setState({ community_details: {...this.state.community_details, priority: e.target.value}})}
                                                displayEmpty
                                                label={t("Priority")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"P1"} value={"P1"}>{t("P1")}</MenuItem>
                                                <MenuItem key={"P2"} value={"P2"}>{t("P2")}</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showEditCommunity: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleUpdateCommunity()}>{t("Update Community")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>

                <Modal
                    open={this.state.showAddPaymentModal}
                    onClose={() => this.setState({showAddPaymentModal: false})}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={"Add Payment"}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddPaymentModal: false })}>
                                        <CloseOutlined/>
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className='mb-3'/>
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Type")} *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.payment_type}
                                                onChange={(e) => this.setState({ payment_type: e.target.value })}
                                                displayEmpty
                                                label={t("Type")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key="credit" value="credit">Credit</MenuItem>
                                                <MenuItem key="debit" value="debit">Debit</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="community-name-input"
                                            label={t("Amount")}
                                            value={this.state.payment_amount}
                                            onChange={(e: any) => this.setState({ payment_amount: e.target.value})}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Comment")}
                                            value={this.state.payment_comment}
                                            onChange={(e: any) => this.setState({ payment_comment: e.target.value})}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddPaymentModal: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({showAddPaymentModal: false}, () => handleAddPayment())}>{t("Add")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>

                <Modal
                    open={this.state.showCustomDateFilter}
                    onClose={() => this.setState({ showCustomDateFilter: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Select Custom Analytics Dates")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showCustomDateFilter: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    mask="____-__-__"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.customFromDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customFromDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    mask="____-__-__"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("To Date") + " *"}
                                                    value={this.state.customToDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customToDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showCustomDateFilter: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.customFromDate || !this.state.customToDate} onClick={() => {this.fetchCommunityEcoStats(); this.setState({showCustomDateFilter: false})}}>{t("Get Analytics")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                open={this.state.showImpactModal}
                onClose={() => this.setState({ showImpactModal: false, impactTitle: "" })}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "35%",
                        maxHeight: "75vh",
                        bgcolor: "white",
                        p: 3,
                        borderRadius: "12px",
                        boxShadow: 24,
                        textAlign: "center",
                        overflowY: "auto"
                    }}
                >
                    {/* Heading */}
                    <Typography variant="h6" sx={{ mb: 3 }}>
                        Community Impact
                    </Typography>

                    {/* Image */}
                    {this.state.impactImage ? (
                        <Box sx={{ width: "100%", mb: 3 }}>
                            <img
                                src={this.state.impactImage}
                                alt="My Impact"
                                style={{
                                    width: "100%",
                                    maxHeight: "430px",
                                    objectFit: "contain",
                                    borderRadius: "10px",
                                }}
                            />
                        </Box>
                    ) : (
                        <Typography>No Image Available</Typography>
                    )}

                    {/* Text Field (same size as image) */}
                    <TextField
                        label="Custom Title (Optional)"
                        fullWidth
                        value={this.state.impactTitle}
                        inputProps={{ maxLength: 75 }}
                        onChange={(e) => this.setState({ impactTitle: e.target.value })}
                        helperText={
                            <span style={{ color: "red" }}>
                                * Up to 75 ({this.state.impactTitle.length}/75)
                            </span>
                        } 
                        sx={{ mb: 3 }}
                    />

                    {/* Buttons */}
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                        <Button
                            style={{ backgroundColor: "grey", color: "white" }}
                            onClick={() => this.setState({ showImpactModal: false,impactTitle: ""  })}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            onClick={async () => {
                                await this.generateMyImpact();   // ⬅ waits for fresh API result
                                this.downloadImpactImage();      // ⬅ downloads after update
                            }}
                        >
                            Download
                        </Button>
                    </Box>
                </Box>
            </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(NeighbourhoodDetails))
